import { TrackColorService } from '@/services/trackColorService'
import type { Track } from '@/types/tour'

type TrackColorSource = Pick<Track, 'clientId' | 'color'>

export function resolveTrackOverlayColor(
  tracks: ReadonlyArray<TrackColorSource> | null | undefined,
  trackClientId?: string | null,
): string {
  const availableTracks = tracks ?? []

  if (trackClientId) {
    const track = availableTracks.find((candidate) => candidate.clientId === trackClientId)
    if (track?.color) {
      return TrackColorService.ensureValidColor(track.color)
    }
  }

  return TrackColorService.getNewTrackColorForTour(availableTracks)
}
